import React, {forwardRef} from "react";
import {
    convertirModena,
    sumaCompensacion,
    sumaIngreso,
    sumaPrestacion,
    sumaTotalPrestaciones
} from "../../shared/utils/utils";
import "./style.scss"

export const TablaDetalleInformeCompensacion = forwardRef(({fieldsFactura, fieldsAsociados, fieldsDataInicial}, ref) => {

    console.log('Asociados:',fieldsAsociados)
    console.log('Factura:',fieldsFactura)

    let compensacin = (fieldsAsociados.length > 0 ? fieldsAsociados[0]['compensacion'] : []);
    let prestacion = (fieldsAsociados.length > 0 ? fieldsAsociados[0]['prestacion'] : []);

    const sumaPrestaciones = sumaPrestacion(fieldsAsociados);

    const sumaCompensaciones = sumaCompensacion(fieldsAsociados);
    const ingreso = sumaIngreso(fieldsAsociados)
    const totales = [...sumaCompensaciones, ...sumaPrestaciones]

    return(

        <div className="tablaDetalleCompensacion" ref={ref}>

            <div className="container mx-4 mt-2 ">
                <div className="flex page-informe-head">

                    <div className="container-tabla-compensa">
                        {<table id="compensacionInforme" className="items-center tabla-compensa-cliente mx-1 bg-transparent border-collapse px-3">
                            <thead>
                            <tr className={"esconder"}>
                                <td className="pt-2">Cliente:</td>
                                <td className="pt-2"> {fieldsFactura.nombre} </td>
                                <td className="pt-2 pl-30">Año:</td>
                                <td className="pt-2"> {fieldsDataInicial.anio} </td>
                                <td className="pt-2 pl-10">Mes:</td>
                                <td className="pt-2"> {fieldsDataInicial.mes} </td>
                                <td className="pt-2 pl-10">Periodo:</td>
                                <td className="pt-2"> {fieldsDataInicial.periodo} </td>
                            </tr>
                            <tr>
                                <th className="px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color">Concepto</th>
                                <th className="px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color">Valor</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold  border-gray-500 border-solid border-gray-500">Codigo factura:</td>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500">{fieldsFactura.num_factura}</td>
                            </tr>
                            <tr>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold border-gray-500 border-solid border-gray-500">Facturado:</td>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500">{convertirModena(fieldsFactura.valor_factura)}</td>
                            </tr>
                            <tr>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold border-gray-500 border-solid border-gray-500">Gastos factura:</td>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500">{convertirModena(fieldsFactura.valor_descuento)}</td>
                            </tr>
                            <tr>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold border-gray-500 border-solid border-gray-500">Sub total:</td>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500">{convertirModena(fieldsFactura.valor_neto)}</td>
                            </tr>
                            <tr>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold border-gray-500 border-solid border-gray-500">Administración:</td>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500">{convertirModena(fieldsFactura.valor_admon)}</td>
                            </tr>
                            <tr>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold border-gray-500 border-solid border-gray-500">Sub total:</td>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500">{convertirModena(fieldsFactura.sub_total_dos)}</td>
                            </tr>
                            {fieldsFactura.tipo_contrato === 'antiguo' ? <>
                                <tr>
                                    <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold border-gray-500 border-solid border-gray-500">Compensación 80%:</td>
                                    <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500">{convertirModena(fieldsFactura.valor_compensacion)}</td>
                                </tr>
                                <tr>
                                    <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold border-gray-500 border-solid border-gray-500">Fondos 20%:</td>
                                    <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500 ">{convertirModena(fieldsFactura.valor_prestaciones)}</td>
                                </tr>
                            </> : <tr>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-left items-center font-bold border-gray-500 border-solid border-gray-500">Prestaciones:</td>
                                <td  className="px-4 align-middle  text-xs whitespace-nowrap p-2 text-right items-center border-gray-500 border-solid border-gray-500 ">{convertirModena(sumaTotalPrestaciones(fieldsAsociados))}</td>
                            </tr>}
                            </tbody>
                        </table>}
                    </div>
                    <div className={'hidden-compensa titulos-centrados'}>
                        <div style={{width:"100%"}}>
                            <span>
                                <h1>LIQUIDACIÓN</h1>
                                <p className="titulos"><b>Cliente:</b> {fieldsFactura.nombre} </p>
                            </span>
                            <span>
                                <p className="titulos"><b>Año:</b> {fieldsDataInicial.anio} </p>
                            </span>
                            <span>
                                <p className="titulos"><b>Mes:</b> {fieldsDataInicial.mes} </p>
                            </span>
                            <span>
                                <p className="titulos"><b>Periodo:</b> {fieldsDataInicial.periodo} </p>
                            </span>
                        </div>
                    </div>
                    <div className={'hidden-compensa hidden-img'}>
                        <div style={{width:"100%"}}>
                            <img className={'img-toa'} alt={"toa"} src="/img/toa.png" style={{marginTop:"10px"}}/>
                        </div>
                    </div>
                </div>
            </div>

            <br/>

            <table id="compensacion" className="items-center main-tabla mx-1 bg-transparent border-collapse px-3">
                <thead>
                <tr>
                    <th className="px-5 whitespace align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-bold text-left primary-color text-lightBlue-300 border-primary-color">CÉDULA</th>
                    <th className="px-5 whitespace align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-bold text-left primary-color text-lightBlue-300 border-primary-color">NOMBRE</th>
                    <th className="px-5 whitespace align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-bold text-left primary-color text-lightBlue-300 border-primary-color">INGRESO</th>
                    {(fieldsAsociados.length > 0 && compensacin.length > 0) && compensacin.map(((data, i) => <th
                        className="px-5 whitespace align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-bold text-left primary-color text-lightBlue-300 border-primary-color "
                        key={i}>{data['descrip_abrev']}<span className="ml-1" style={{
                        fontSize: '.8em',
                        display: "block"
                    }}>{data['porcentaje']}%</span></th>))}
                    {(fieldsAsociados.length > 0 && prestacion.length > 0) && prestacion.map(((data, i) => <th
                        className="px-5 whitespace align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-bold text-left primary-color text-lightBlue-300 border-primary-color "
                        key={i}>{data['descrip_abrev']}<span className="ml-1" style={{
                        fontSize: '.8em',
                        display: "block"
                    }}>{data['porcentaje']}%</span></th>))}
                </tr>
                </thead>
                <tbody className="pb-2">
                {fieldsAsociados.map((field, i) => {
                    return <tr key={i}>
                        <td className="px-4 align-middle asociado-doc text-xs whitespace-nowrap p-4 text-left items-center">
                            <span className="ml-3 text-ajuste font-bold text-blueGray-600">{field.num_doc} </span>
                        </td>
                        <td className="px-4 align-middle  text-xs whitespace-nowrap p-4 text-left items-center">
                            <span className="ml-3 text-ajuste asociado-nombre font-bold text-blueGray-600">{field.nombres} </span>
                        </td>
                        <td className="px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right items-center">
                                        <span
                                            className="ml-3 text-ajuste font-bold text-blueGray-600">{convertirModena(field.sub_total)} </span>
                        </td>
                        {(field['compensacion'].length > 0 ) && field['compensacion'].map(((data, i) => <td
                            className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right items-center"
                            key={i}><span
                            className="ml-4 text-ajuste font-bold text-blueGray-600">{convertirModena(data['valor_porcentaje'])} </span>
                        </td>))}
                        {(field['prestacion'].length > 0 ) && field['prestacion'].map(((data, i) => <td
                            className="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right items-center"
                            key={i}><span
                            className="ml-4 text-ajuste font-bold text-blueGray-600">{convertirModena(data['valor_porcentaje'])} </span>
                        </td>))}
                    </tr>
                })}
                </tbody>
                <tfoot>
                    <tr className="px-5 text-ajuste align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color">
                        <td className="px-5 text-ajuste align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-right primary-color text-lightBlue-300 border-primary-color"></td>
                        <td className="px-5 align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left primary-color text-lightBlue-300 border-primary-color">TOTALES</td>
                        <td className="px-5 text-ajuste align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-right primary-color text-lightBlue-300 border-primary-color">{convertirModena(ingreso)}</td>
                        {totales.length > 0 && totales.map(((data, i) => <td
                            className="px-5  text-ajuste align-middle border-gray-500 border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-right primary-color text-lightBlue-300 border-primary-color "
                            key={i}>{convertirModena(data[1])}
                        </td>))}
                    </tr>
                </tfoot>
            </table>


        </div>
    )
});


TablaDetalleInformeCompensacion.defaultProps = {
    fieldsAsociados: [],
    fieldsFactura: {},
    fieldsDataInicial: {}
}
